import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import './dataFieldRow.scss';
function DatafieldRow({ title, value, symbol }) {
    return (_jsxs("div", { className: "datafield-row", children: [_jsx("span", { className: "title", children: title }), _jsxs("span", { className: "value", children: [value, " ", symbol] })] }));
}
DatafieldRow.propTypes = {
    title: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    symbol: PropTypes.string,
};
DatafieldRow.defaultProps = {
    symbol: null,
};
export default DatafieldRow;
